import { Address_Country as Country } from "gen/proto/address/models_pb"
import { countryNameFromPB } from "shared-ts/libs/country"

import { Combobox } from "../../../base/input/Combobox"

interface CountrySelectorProps {
  value: Country
  // When omitted, the selector renders as a read-only display of `value`.
  onChange?: (country: Country) => void
  isInModal?: boolean
}

const COUNTRY_OPTIONS: readonly Country[] = [Country.US, Country.CA]

export function CountrySelector({
  value,
  onChange,
  isInModal,
}: CountrySelectorProps) {
  return (
    <div className="sm:col-span-2">
      <Combobox<Country>
        data-testid="address-country-input"
        label="Country"
        placeholder=""
        items={[...COUNTRY_OPTIONS]}
        selectedItem={value}
        onSelectItem={(c) => {
          if (c != null && onChange) onChange(c)
        }}
        keyExtractor={(c) => String(c)}
        valueExtractor={(c) => countryNameFromPB(c)}
        optionsClassName={isInModal ? "z-50" : undefined}
        isOpenOnFocus
        disabled={!onChange}
      />
    </div>
  )
}
